<h3 mat-dialog-title>{{ (data.isDelete
    ? (data.summary.updated === 0 ? 'Risk registers could not be deleted' : 'Some risk registers were not deleted')
    : (data.summary.updated === 0 ? 'Risk registers could not be updated' : 'Some risk registers were not updated')) | translate }}</h3>

<mat-dialog-content>
    <p class="result-summary">
        {{ (data.isDelete ? '{{updated}} of {{total}} risk registers deleted, {{failed}} failed' : '{{updated}} of {{total}} risk registers updated, {{failed}} failed') | translate: { updated: data.summary.updated, total: data.summary.total, failed: data.summary.failed } }}
    </p>

    <ul class="failure-list">
        @for (failure of data.summary.failures; track $index) {
            <li class="failure-item">
                <span class="failure-label">{{ failure.label }}</span>
                @if (failure.reason) {
                    <span class="failure-reason">{{ failure.reason }}</span>
                }
            </li>
        }
    </ul>

    @if (data.failedStaySelected) {
        <p class="stay-selected-hint">{{ 'Failed registers stay selected so you can fix them and try again.' | translate }}</p>
    }
</mat-dialog-content>

<mat-dialog-actions class="result-actions">
    <button class="btn save-modal-btn" (click)="onClose()">{{ 'Close' | translate }}</button>
</mat-dialog-actions>
